// 构建变量配置
const buildConfig = (variable, ext = {}) => {
  return {
    label: variable, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: variable, // 确认后输入的内容
    ...ext
  }
}
/**
 * 系统扩展的内部变量
 * @author Caesar Liu
 * @date 2020-11-20 17:42
 */
module.exports = [
  buildConfig('_author', { documentation: '生成人姓名' }),
  buildConfig('_email', { documentation: '生成人邮箱' }),
  buildConfig('_mobile', { documentation: '生成人手机号码，如180****9999' }),
  buildConfig('_filePath', { documentation: '文件生成的最终路径，不包含文件名' }),
  buildConfig('_fileName', { documentation: '文件生成的最终名称，不包含文件后缀' }),
  buildConfig('_fullFileName', { documentation: '文件生成的最终名称，包含文件后缀' }),
  buildConfig('_table', { documentation: '数据模型对象' }),
  buildConfig('_table.type', { documentation: '数据模型类型，TABLE表示单表，RELATION表示关联表' }),
  buildConfig('_table.name', { documentation: '数据模型名称' }),
  buildConfig('_table.camelCaseName', { documentation: '数据模型名称（驼峰命名法）' }),
  buildConfig('_table.pascalCaseName', { documentation: '数据模型名称（帕斯卡命名法）' }),
  buildConfig('_table.underScoreCaseName', { documentation: '数据模型名称（下划线命名法）' }),
  buildConfig('_table.kebabCaseName', { documentation: '数据模型名称（中划线命名法）' }),
  buildConfig('_table.remark', { documentation: '数据模型备注（通常为表备注）' }),
  buildConfig('_table.pks', { documentation: '数据模型中的主键对象数组' }),
  buildConfig('_table.relations', { documentation: '数据模型的关联记录，仅在_table.type为RELATION时有值' }),
  buildConfig('_table.rows', { documentation: '数据模型行对象数组（通常为表字段对象）' }),
  buildConfig('_tables', { documentation: '当前生成所使用的所有数据模型' }),
  buildConfig('_project', { documentation: '项目对象' }),
  buildConfig('_project.enName', { documentation: '项目英文名' }),
  buildConfig('_project.zhName', { documentation: '项目中文名' }),
  buildConfig('_project.description', { documentation: '项目描述' }),
  buildConfig('_yyyy', { documentation: '生成年份，4位，如2099' }),
  buildConfig('_yy', { documentation: '生成日期：年份，2位，如99' }),
  buildConfig('_MM', { documentation: '生成日期：月份，2位，如08' }),
  buildConfig('_dd', { documentation: '生成日期：天，2位，如08' }),
  buildConfig('_weekOfMonth', { documentation: '生成日期在本月第几周' }),
  buildConfig('_weekOfYear', { documentation: '生成日期在本年第几周' }),
  buildConfig('_HH', { documentation: '生成时间：小时（24时制）' }),
  buildConfig('_hh', { documentation: '生成时间：小时（12时制）' }),
  buildConfig('_mm', { documentation: '生成时间：分钟' }),
  buildConfig('_ss', { documentation: '生成时间：秒' }),
  buildConfig('_sss', { documentation: '生成时间：毫秒' })
]
